import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import {infoStatus} from '../../core/redux/status'
import {average} from '../../core/mathz'
import {getAdministrativeDivision} from '../../core/administrativeDivision'
import DashboardPanel from '../../core/components/DashboardPanel'
import DashboardPanelAdd from '../../core/components/DashboardPanelAdd'
import PercentageDashboardPanel from '../../core/components/PercentageDashboardPanel'
import Map, {percentageStyle} from '../../core/components/Map'
import {updateProviderCoverageCriteria} from '../actions'
import i18n from '../i18n'
import style from './ProviderCoverageDashboard.less'

function activityAggregator(reference) {
    return (result, administrative) => {
        administrative.coverages.forEach((coverage) => {
            const aggrega = result.activityAggregation.find((a) => a.activity.uid == coverage.activityUid)

            if (aggrega) {
                aggrega.coverage = aggrega.coverage + (coverage.coverage || (coverage.covered && 1 || 0))
                return
            }

            const resultActivity = reference.find((a) => a.uid == coverage.activityUid)
            if (resultActivity) {
                const aggrega = {
                    activity: resultActivity,
                    coverage: coverage.coverage || (coverage.covered && 1 || 0)
                }

                result.activityAggregation.push(aggrega)
            } else {
                console && console.warn('activity "' + coverage.activityUid + '" doesn\'t exist in referentiel')
            }

            result.activityCount++
        })

        return result
    }
}

function administrativeAggregator(reference) {
    return (result, administrative) => {
        if (administrative.cityUid) {
            const aggrega = {
                city: {cityUid: administrative.cityUid, zipCodes: administrative.zipCodes, name: administrative.name},
                coverage: administrative.coverages.reduce((r, c) => r + (c.coverage || (c.covered && 1 || 0)), 0)
            }

            result.cityAggregation = result.cityAggregation || []
            result.cityAggregation.push(aggrega)
        }

        if (administrative.departmentNumber) {
            const aggrega = {
                department: {departmentNumber: administrative.departmentNumber, name: administrative.name},
                coverage: administrative.coverages.reduce((r, c) => r + (c.coverage || (c.covered && 1 || 0)), 0)
            }

            result.departmentAggregation = result.departmentAggregation || []
            result.departmentAggregation.push(aggrega)
        }

        result.administrativeCount++
        return result
    }
}

class ProviderCoverageDashboard extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            activityAggregation: []
        }
    }

    componentWillMount() {
        const {coverage, reference} = this.props

        const {activityAggregation, activityCount} = coverage.reduce(activityAggregator(reference), {activityAggregation: [], activityCount: 0})
        const {cityAggregation, departmentAggregation, administrativeCount} = coverage.reduce(administrativeAggregator(reference), {administrativeCount: 0})
        this.setState({activityAggregation, activityCount, cityAggregation, departmentAggregation, administrativeCount})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.coverage != this.props.coverage
            || nextProps.reference != this.props.reference) {
            const {coverage, reference} = nextProps

            const {activityAggregation, activityCount} = coverage.reduce(activityAggregator(reference), {activityAggregation: [], activityCount: 0})
            const {cityAggregation, departmentAggregation, administrativeCount} = coverage.reduce(administrativeAggregator(reference), {administrativeCount: 0})
            this.setState({activityAggregation, activityCount, cityAggregation, departmentAggregation, administrativeCount})
        }
    }

    _updateCriteria(event, criteria) {
        const {dispatch} = this.props

        if (event.preventDefault) {
            event.preventDefault()
        }

        return dispatch(updateProviderCoverageCriteria(criteria))
    }

    render() {
        const {dispatch, coverage} = this.props
        const {activityAggregation, activityCount, cityAggregation, departmentAggregation, administrativeCount} = this.state

        const globalCoveragePercent = average({
            source: activityAggregation.map((a) => a.coverage * 100 / administrativeCount)
        })

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        const mapPercentageStyle = percentageStyle({
            identify: (a) => a.coverage / activityCount
        })

        return (
            <div>
                <Row>
                    <Col sm={6} md={4}>
                        <PercentageDashboardPanel light
                            header={panelHeader(i18n.byActivity)}
                            display={(a) => a.activity.label}
                            identify={(a) => a.coverage}
                            total={administrativeCount}
                            value={activityAggregation} />
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanelAdd
                            onClick={() => dispatch(infoStatus(i18n.featureNotImplemented))} />
                    </Col>
                    <Col sm={6} md={4}>
                        <DashboardPanel light
                            header={panelHeader(i18n.coverageRate)}>
                            <div className={style.coverageRate}>
                                {!isNaN(globalCoveragePercent) && (
                                    <span className={style.rate}>{globalCoveragePercent} %</span>
                                )}
                            </div>
                        </DashboardPanel>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6} md={4}>
                        {cityAggregation && (
                            <PercentageDashboardPanel light
                                size='large'
                                header={panelHeader(i18n.byCity)}
                                display={(a) => a.city.name}
                                identify={(a) => a.coverage}
                                total={activityCount}
                                onClick={(e, a) => this._updateCriteria(e, {city: a.city, department: null, zipCodes: null})}
                                value={cityAggregation} />
                        )}
                        {departmentAggregation && (
                            <PercentageDashboardPanel light
                                size='large'
                                header={panelHeader(i18n.byDepartment)}
                                display={(a) => a.department.name}
                                identify={(a) => a.coverage}
                                total={activityCount}
                                onClick={(e, a) => this._updateCriteria(e, {department: a.department, city: null, zipCodes: null})}
                                value={departmentAggregation} />
                        )}
                    </Col>
                    <Col sm={12} md={8}>
                        {cityAggregation && (
                            <DashboardPanel light
                                size='large'
                                header={panelHeader(i18n.cityCoverageMap)}>
                                <Map
                                    style={mapPercentageStyle}
                                    display={(a) => getAdministrativeDivision({division: 'city', departmentCode: a.city.zipCodes[0].toString().substring(0, 2), code: a.city.cityUid})}
                                    identify={(a) => a.city.cityUid}
                                    onClick={(e, a) => this._updateCriteria(e, {city: a.city, department: null, zipCodes: null})}
                                    value={cityAggregation} />
                            </DashboardPanel>
                        )}
                        {departmentAggregation && (
                            <DashboardPanel light
                                size='large'
                                header={panelHeader(i18n.departmentCoverageMap)}>
                                <Map
                                    style={mapPercentageStyle}
                                    display={(a) => getAdministrativeDivision({division: 'department', code: a.department.departmentNumber})}
                                    identify={(a) => a.department.departmentNumber}
                                    onClick={(e, a) => this._updateCriteria(e, {department: a.department, city: null, zipCodes: null})}
                                    value={departmentAggregation} />
                            </DashboardPanel>
                        )}
                    </Col>
                </Row>
            </div>
        )
    }
}

ProviderCoverageDashboard = connect((state) => ({
    coverage: state.provider.coverage.coverage,
    reference: state.reference.activityRef
}))(ProviderCoverageDashboard)

export default ProviderCoverageDashboard


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderCoverageDashboard.js